// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { Observable } from 'rxjs';
import { Joove } from 'src/app/@framework/core/Joove';

export abstract class IPagesService
{
    abstract refreshContext(page: string, action: string) : Observable<Joove.IContext>;
}

export abstract class IFormControlsAdapter<T, S> {
  abstract fromModel(model: T): S;
  abstract toModel(model: T, formControlsModel: S): T;
}